import { render, staticRenderFns, recyclableRender, components } from "./itinerary.vue?vue&type=template&id=3d3e0a9e&scoped=true&"
var renderjs
import script from "./itinerary.vue?vue&type=script&lang=js&"
export * from "./itinerary.vue?vue&type=script&lang=js&"
import style0 from "./itinerary.vue?vue&type=style&index=0&id=3d3e0a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3e0a9e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/itinerary/itinerary.vue"
export default component.exports